import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppLayout from '../Layout/Layout';
import { workspaceRoutes } from './WorkspaceRoutes';
import { useAuth } from '../Auth/AuthContext';
import { NotFoundState, UnauthorizedState } from '../Components/Common/WorkspaceState';

const AuthorizedPage = ({ permission, children }) => {
  const { hasPermission } = useAuth();
  return hasPermission(permission) ? children : <div className="container-fluid py-4"><UnauthorizedState /></div>;
};

const LayoutRoutes = () => {

  return (
    <>
      <Routes>
        <Route element={<AppLayout />}>
          {workspaceRoutes.map(({ path, element, permission }) => (
            <Route key={path} path={path} element={<AuthorizedPage permission={permission}>{element}</AuthorizedPage>} />
          ))}
          <Route path="*" element={<div className="container-fluid py-4"><NotFoundState /></div>} />
        </Route>
      </Routes>
    </>
  );
};

export default LayoutRoutes;
